import { EVENTBRITE_CATEGORY, EVENTBRITE_SUB_CATEGORY } from './constants';

export function isCategory(target: string) {
    return target.startsWith(EVENTBRITE_CATEGORY);
}

export function isSubCategory(target: string) {
    return target.startsWith(EVENTBRITE_SUB_CATEGORY);
}
